// Canadian Football reporting config.
//
// CFL stats semantics currently mirror American Football — the
// reporting-api surfaces the same metrics + position groups for both —
// so non-pitch fields reuse `americanFootballData`. What differs is the
// pitch geometry (longer field, deeper end zones, hashes set 24yd from
// the sideline) — drawn by `drawCanadianFootballPitch` in
// `@frontend/pitch` when the PitchMap receives this config's `.pitch`.
//
// When CFL-specific stats / positions land, peel them out of the
// spread here and declare them explicitly.
import { defaultPitch as canadianPitch } from '@frontend/core/lib/domains/sports/canadian_football/pitch'
import type { UnitSystem } from '@frontend/core/lib/domains/units/types'
import { ReportingSport } from '@frontend/core/lib/domains/reporting/types'
import { americanFootballData } from './amf'
import { ReportingSportConfig, type ReportingSportData } from './base'

const canadianFootballData: ReportingSportData = {
  ...(americanFootballData as ReportingSportData),
  sport: ReportingSport.CanadianFootball,
  displayName: 'Canadian Football',
  emoji: '🏈',
  themeClass: 'sport-cfl',
  pitch: {
    sport: canadianPitch.sport,
    coordinates: canadianPitch.pitch.coordinates ?? {}
  }
}

export class CanadianFootballConfig extends ReportingSportConfig {
  constructor(unitSystem: UnitSystem) {
    super(unitSystem, canadianFootballData)
  }
}
